import api from "api/config";

export const GetDashboardGuestSectionsAPI = (data) =>
  api({ method: "POST", url: "/api/v1/dashboard/guest-sections", data });

export const GetDashboardDailyTasksAPI = (data) =>
  api({ method: "POST", url: "/api/v1/dashboard/daily-tasks", data });

export const GetDashboardCountersAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/dashboard/counters",
    data,
  });

  return response;
};

export const GetDashboardOccupancyAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/dashboard/occupancy",
    data,
  });

  return response;
};

export const GetDashboardReservationsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/dashboard/reservations",
    data,
  });

  return response;
};

export const GetDashboardPreferenceInsightsAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/dashboard/preference-insights",
    data,
  });

  return response;
};
